/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-user\":\"Sirkel med brukerprofil\"}");